import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import DataTable from "../../../components/table/data/DataTable";
import { IFilter } from "../../../components/table/data/filter/DataFilter";
import Toolbar from "../../../components/toolbar/Toolbar";
import { useLocalColumns } from "../../../hooks/useTableColumns";
import { ILocalDisplay } from "../../../models/requests/local/localDisplay";
import LocalService from "../../../services/local/LocalService";
import DownloadTable from "../../../utils/download/downloadDataTable";

const LocalPage = () => {
    const columns = useLocalColumns();
    const navigate = useNavigate();
    const [isFilterActive, setIsFilterActive] = useState<boolean>(true);
    const [locals, setLocals] = useState<ILocalDisplay[]>([]);
    const { t } = useTranslation();

    const [filteredRows, setFilteredRows] = useState(locals);
    const [selectedFilters, setSelectedFilters] = useState<
        Map<string, IFilter>
    >(new Map());

    const visibleFilters: string[] = [];
    selectedFilters.forEach((filter, field) => {
        if (!filter.isActive || !filter.request) return;
        const column = columns.find((column) => column.field === field);
        visibleFilters.push(`${column?.headerName}: ${t(`periodical:filter.${filter.type}`)} ${filter.request}`);
    });

    const downloadTable = new DownloadTable("local", filteredRows, columns, t("table.local.title"), visibleFilters);

    useEffect(() => {
        LocalService.GetLocalsBuildingsByCompany().then((locals) => {
            const localDisplays: ILocalDisplay[] = locals.localDetails.map((local) => ({
                id: local.local.id,
                buildingId: local.building.id,
                name: local.local.name,
                profileName: local.profile.name,
                floorName: local.floor.name,
                floorId: local.floor.id,
                profileId: local.profile.id,
                propertyGroupId: local.building.propertyGroupId,
                buildingName: local.building.name,
                tagMacAddress: local.local.tagMacAddress,
                codes: local.codes.map((code) => code),
                routes: local.routes || [],
                isLocked: local.local.isLocked,
                cleaningSchedule: local.cleaningSchedule,
                alarmCode: local.local.alarmCode,
                specification: local.local.specification || "",
                buildings: locals.buildings,
                servicePlusStickerCode: local.local.servicePlusStickerCode,
            }));
            setLocals(localDisplays);
        })
    }, []);

    return (
        <>
            <Box sx={{ width: "100%", height: "100%" }}>
                <Toolbar
                    onFilterClick={() => setIsFilterActive((old) => !old)}
                    onCreate={() => navigate("add")}
                    isFilterActive={isFilterActive}
                    downloadButtons={[
                        { label: "Excel", onClick: () => downloadTable.GetExcel(t("header.exportedBy"), t("header.exportDate")) },
                        { label: "CSV", onClick: () => downloadTable.GetCSV() },
                        { label: "PDF", onClick: () => downloadTable.GetPDF(t("header.exportedBy"), t("header.exportDate")) }
                    ]}
                />
                <DataTable
                    dense
                    disableFiltrer={!isFilterActive}
                    rows={locals}
                    columns={columns}
                    onRowClick={(row) =>
                        navigate("edit", { state: { localData: row } })
                    }
                    getRowNavTo={(row) => "edit"}
                    onSetFilter={(filteredRows, selectedFilters) => {
                        setFilteredRows(filteredRows)
                        setSelectedFilters(selectedFilters)
                    }}
                />
            </Box>
        </>
    );
};
export default LocalPage;
